/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Feature_1Inputs */

const en_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support private, independent search`)
};

const id_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukung penelusuran pribadi dan independen`)
};

const ms_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sokong carian privet dan bebas`)
};

const ca_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dona suport a la cerca privada i independent`)
};

const cs_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podporuje soukromé, nezávislé vyhledávání`)
};

const da_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støt privat, uafhængig søgning`)
};

const de_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterstütze eine private, unabhängige Suchfunktion`)
};

const et_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toeta privaatset ja sõltumatut otsingut`)
};

const es_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apoya las búsquedas privadas e independientes`)
};

const fr_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutenez la recherche privée et indépendante`)
};

const hr_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podržite privatnu, nezavisnu tražilicu`)
};

const it_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supporta la ricerca privata e indipedente su Internet `)
};

const lv_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atbalstiet privātu, neatkarīgu meklēšanu`)
};

const lt_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remti privačią, nepriklausomą paiešką`)
};

const hu_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Támogatja a privát, független keresést`)
};

const nl_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacygericht, onafhankelijk zoeken`)
};

const nb_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støtte for private, uavhengige søk`)
};

const pl_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wesprzyj prywatne i niezależne wyszukiwanie`)
};

const pt_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dê o seu apoio à pesquisa privada e independente`)
};

const ro_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprijină căutarea privată, independentă`)
};

const sk_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podporte súkromné a nezávislé vyhľadávanie`)
};

const sl_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podprite zasebno in neodvisno iskanje`)
};

const fi_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tue yksityistä ja riippumatonta hakua`)
};

const sv_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stöd privat, oberoende sökning`)
};

const vi_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hỗ trợ tìm kiếm riêng tư, độc lập`)
};

const tr_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik odaklı, bağımsız aramayı destekleyin`)
};

const el_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Υποστηρίζει ιδιωτική, ανεξάρτητη αναζήτηση`)
};

const bg_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подкрепяш частното, независимо търсене`)
};

const ru_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поддержите приватный независимый браузер`)
};

const sr_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подржите приватну, независну претрагу`)
};

const uk_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтримати приватний танезалежний пошук`)
};

const ka_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`მხარი დაუჭირეთ კერძო, დამოუკიდებელ ძიებას`)
};

const hi_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सपोर्ट प्राइवेट इंडिपेंडेंट सर्च `)
};

const th_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สนับสนุนการค้นหาที่เป็นส่วนตัวและเป็นอิสระ`)
};

const ko_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`독립적이고 프라이빗한 검색 지원`)
};

const zh_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持私密独立搜索`)
};

const zh_tw_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持私密、獨立的搜尋`)
};

const ja_search_feature_1 = /** @type {(inputs: Search_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートで独立した検索をサポート`)
};

/**
* | output |
* | --- |
* | "Support private, independent search" |
*
* @param {Search_Feature_1Inputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const search_feature_1 = /** @type {((inputs?: Search_Feature_1Inputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Feature_1Inputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_feature_1(inputs)
	if (locale === "ms") return ms_search_feature_1(inputs)
	if (locale === "ca") return ca_search_feature_1(inputs)
	if (locale === "cs") return cs_search_feature_1(inputs)
	if (locale === "da") return da_search_feature_1(inputs)
	if (locale === "de") return de_search_feature_1(inputs)
	if (locale === "et") return et_search_feature_1(inputs)
	if (locale === "es") return es_search_feature_1(inputs)
	if (locale === "fr") return fr_search_feature_1(inputs)
	if (locale === "hr") return hr_search_feature_1(inputs)
	if (locale === "it") return it_search_feature_1(inputs)
	if (locale === "lv") return lv_search_feature_1(inputs)
	if (locale === "lt") return lt_search_feature_1(inputs)
	if (locale === "hu") return hu_search_feature_1(inputs)
	if (locale === "nl") return nl_search_feature_1(inputs)
	if (locale === "nb") return nb_search_feature_1(inputs)
	if (locale === "pl") return pl_search_feature_1(inputs)
	if (locale === "pt") return pt_search_feature_1(inputs)
	if (locale === "ro") return ro_search_feature_1(inputs)
	if (locale === "sk") return sk_search_feature_1(inputs)
	if (locale === "sl") return sl_search_feature_1(inputs)
	if (locale === "fi") return fi_search_feature_1(inputs)
	if (locale === "sv") return sv_search_feature_1(inputs)
	if (locale === "vi") return vi_search_feature_1(inputs)
	if (locale === "tr") return tr_search_feature_1(inputs)
	if (locale === "el") return el_search_feature_1(inputs)
	if (locale === "bg") return bg_search_feature_1(inputs)
	if (locale === "ru") return ru_search_feature_1(inputs)
	if (locale === "sr") return sr_search_feature_1(inputs)
	if (locale === "uk") return uk_search_feature_1(inputs)
	if (locale === "ka") return ka_search_feature_1(inputs)
	if (locale === "hi") return hi_search_feature_1(inputs)
	if (locale === "th") return th_search_feature_1(inputs)
	if (locale === "ko") return ko_search_feature_1(inputs)
	if (locale === "zh") return zh_search_feature_1(inputs)
	if (locale === "zh-tw") return zh_tw_search_feature_1(inputs)
	if (locale === "ja") return ja_search_feature_1(inputs)
	return en_search_feature_1(inputs)
});